

















































import { defineComponent } from "@vue/composition-api";
import {SfIcon} from '@storefront-ui/vue';
export default defineComponent({
    props:{
        isAvailable:{
            type:Boolean,
            required: true
        }
    },
    components:{
        SfIcon
    },
    setup(props) {
        return {
            availabilityLabel : props.isAvailable ? 'available':'not available',
        }
    },
});
